{
  "app": {
    "approveFailed": "approve failed: {{error}}",
    "archive": "Archive",
    "archiveFailed": "archive failed: {{error}}",
    "archiveThreadFailed": "archive failed: {{error}}",
    "archiveThreadMessage": "\"{{title}}\" will be hidden from the sidebar. Conversation history is preserved on disk.",
    "archiveThreadMidTurn": "cannot archive a thread mid-turn — wait for it to finish",
    "archiveThreadTitle": "Archive thread?",
    "bulkApproveAccepted": "✓ {{n}} accepted · {{parts}}",
    "bulkApproveFailed": "bulk approve: {{failed}} of {{total}} failed",
    "bulkApproveToCards": "{{n}}→cards",
    "bulkApproveToOpen": "{{n}}→OPEN",
    "cardArchived": "Archived {{id}}",
    "cardDeleted": "Deleted {{id}}",
    "cardDeletedBrokenReferences": "Deleted {{id}} — broken references in: {{refs}}",
    "cardDeletedBrokenRefs": "Deleted {{id}}; broken refs: {{refs}}",
    "cardMarkedStatus": "Marked {{id}} as {{status}}",
    "cardSaved": "Saved {{id}}",
    "cardStatusCleared": "Cleared status on {{id}}",
    "cardWrittenBrokenRefs": "{{id}} written with broken refs: {{refs}}",
    "cardsMarkedStale": "{{id}} re-asserted — {{n}} dependent cards flagged stale",
    "cardsUndone": "Undid {{n}} cards",
    "deleteFailed": "delete failed: {{error}}",
    "discard": "Discard",
    "discardChangesMessage": "You have unsaved edits in the open card. Continuing will lose them.",
    "discardChangesTitle": "Discard unsaved changes?",
    "generateFailed": "generate failed: {{error}}",
    "markStatusFailed": "mark status failed: {{error}}",
    "packBlank": "blank",
    "packChanged": "Pack changed to {{pack}}",
    "projectCreated": "Created project \"{{name}}\"",
    "projectDeleted": "Deleted project",
    "projectImported": "Imported \"{{name}}\"",
    "proposalApproved": "Approved {{id}} → {{kind}}",
    "proposalRejected": "Rejected {{id}}",
    "proposalRejectedMarked": "Rejected {{id}} · marked {{n}} cards",
    "rejectFailed": "reject failed: {{error}}",
    "renameProjectFailed": "rename project failed: {{error}}",
    "saveFailed": "save failed: {{error}}",
    "setModelPreferenceFailed": "set model preference failed: {{error}}",
    "threadArchived": "Thread archived",
    "threadTitleAnswer": "Answer",
    "threadTitleDiscuss": "Discuss",
    "undo": "Undo",
    "undoDeleteFailed": "undo: {{failed}} of {{total}} delete failed",
    "untitled": "untitled",
    "cardsMarkedStaleFirst": "You just changed decision {{id}} — {{n}} dependent card(s) flagged stale. This is what separates Draftlize from a chat window: your thinking stays consistent."
  },
  "cardBody": {
    "jumpTo": "jump to {{id}}"
  },
  "cardPeek": {
    "approveTooltip": "apply edits and promote to {{kind}}",
    "approving": "Approving…",
    "archive": "archive",
    "archiveTooltip": "soft-hide from the lens · wikilinks still resolve",
    "brokenRefs": "broken refs:",
    "brokenRefsTooltip": "These wikilink targets don't exist in the project.",
    "byAgent": "BY AGENT",
    "byYou": "BY YOU",
    "bySuggested": "SUGGESTED",
    "byRevised": "REVISED",
    "closeHint": "esc · click outside to close",
    "closePeekAria": "Close peek",
    "confirmDelete": "Delete {{id}} permanently?",
    "confirmReject": "Reject and delete {{id}}?",
    "copy": "copy",
    "customKindPlaceholder": "custom kind",
    "deleteReasonPlaceholder": "reason (optional, shown in Deleted view)",
    "deleting": "Deleting…",
    "editLabel": "EDIT",
    "fieldBody": "BODY",
    "fieldKind": "KIND",
    "fieldPack": "PACK",
    "fieldTitle": "TITLE",
    "history": "history",
    "historyTooltip": "see every revision of this card",
    "jumpTo": "jump to {{id}}",
    "kindOther": "other…",
    "markStatusTooltip": "Mark this card's implementation status",
    "implTimelineLabel": "IMPLEMENTATION",
    "implTimeline": {
      "proposed": {
        "label": "PROPOSED",
        "note": "Agreed in discussion — no code yet."
      },
      "building": {
        "label": "BUILDING",
        "note": "A coding agent is working on this right now."
      },
      "built": {
        "label": "BUILT",
        "note": "Shipped — the implementation matches this card."
      },
      "drift_detected": {
        "label": "DRIFT",
        "note": "This card changed after it was built — the implementation may be out of date."
      }
    },
    "packPlaceholder": "(none)",
    "reject": "Reject",
    "saveAndApprove": "Save & Approve → {{kind}}",
    "saveChangesTooltip": "save changes",
    "saveGapTooltip": "save the gap (still awaiting approval)",
    "saving": "Saving…",
    "seeHistoryOfDeleted": "see history of deleted {{id}}",
    "stale": "· STALE",
    "statusBuilding": "building",
    "statusBuilt": "built",
    "statusClear": "(clear)",
    "statusDriftDetected": "drift_detected",
    "statusProposed": "proposed",
    "unarchive": "unarchive",
    "unarchiveTooltip": "restore to the lens (default Time / Status views)",
    "unsaved": "· UNSAVED",
    "uriTooltip": "paste @<this URI> in Claude Code to pin as context",
    "yesDelete": "Yes, delete",
    "yesReject": "Yes, reject"
  },
  "graphShare": {
    "title": "SHARE CARD",
    "building": "Composing the share card…",
    "savePng": "Save image",
    "copyLink": "Copy link",
    "copied": "Copied",
    "error": "Could not build the card: {{error}}",
    "sizeHint": "1080×1440",
    "statsCards_one": "{{count}} card",
    "statsCards_other": "{{count}} cards",
    "statsDecisions_one": "{{count}} decision",
    "statsDecisions_other": "{{count}} decisions",
    "tagline": "Incubate your ideas with Draftlize"
  },
  "cardRow": {
    "brokenRefs": "broken refs:",
    "brokenRefsTooltip": "These wikilink targets don't exist in the project.",
    "byAgent": "BY AGENT",
    "byYou": "BY YOU",
    "bySuggested": "SUGGESTED",
    "byRevised": "REVISED",
    "implStatus": {
      "building": {
        "label": "BUILDING",
        "tooltip": "In progress"
      },
      "built": {
        "label": "✓ BUILT",
        "tooltip": "Implementation shipped"
      },
      "drift_detected": {
        "label": "⚠ DRIFT",
        "tooltip": "Spec changed after implementation. Re-build or re-mark."
      },
      "proposed": {
        "label": "PROPOSED",
        "tooltip": "Acknowledged for build"
      }
    },
    "jumpTo": "jump to {{id}}",
    "less": "— less",
    "mcpRecentTooltip": "read by an external MCP client in the last 24h",
    "more": "+ more",
    "pinManualTooltip": "manually placed by user",
    "pinResetTooltip": "you placed this here · click to reset to LLM placement",
    "seeHistoryOfDeleted": "see history of deleted {{id}}",
    "stale": "· STALE",
    "unknownCard": "unknown card"
  },
  "cards": {
    "addAFrame": "Add a frame",
    "addCardsFirst": "add cards first",
    "addFrameMenu": "Add frame…",
    "allCards": "ALL CARDS",
    "buildingExport": "building export…",
    "cardCount_one": "{{count}} card",
    "cardCount_other": "{{count}} cards",
    "cardsLandHere": "Cards land here.",
    "cardsLandHereBody": "As the agent writes cards, they appear in this column. After ~6 cards the system will help you organize them into a frame.",
    "collecting": "COLLECTING…",
    "collectingBody_one": "{{count}} of 6 cards. Keep chatting; once you have 6, the agent can suggest a structure.",
    "collectingBody_other": "{{count}} of 6 cards. Keep chatting; once you have 6, the agent can suggest a structure.",
    "computingLayout": "computing layout…",
    "deleteFrame": "Delete frame",
    "deleteFrameConfirm": "Delete frame \"{{name}}\"? Placements for this frame are removed; cards themselves are unaffected.",
    "deleted": "DELETED",
    "deletedCount_one": "{{count}} deleted",
    "deletedCount_other": "{{count}} deleted",
    "errDelete": "delete",
    "errLoadFrame": "load frame",
    "errLoadFrames": "load frames",
    "errOverride": "override",
    "errRename": "rename",
    "errReset": "reset",
    "exportFailed": "export failed",
    "exportHint": "download .zip — cards, deletions, full history, threads",
    "exporting": "exporting…",
    "frameMenu": "frame menu",
    "gapCountHint": "MECE-required nodes that have no cards yet",
    "gapCount_one": "{{count}} gap",
    "gapCount_other": "{{count}} gaps",
    "generateDoc": "Generate · design doc",
    "generateDocHint": "generate a design doc",
    "generating": "Generating…",
    "hidden": "HIDDEN",
    "hiddenHint": "excluded from this lens — drag to a node to bring back, or click 📌 to let the LLM decide",
    "lensStatus": "Status",
    "lensStatusSubtitle": "grouped by kind · decision → statement → gap → …",
    "lensTime": "Time",
    "lensTimeSubtitle": "newest first · the default",
    "llmCategorized": "LLM-categorized",
    "noCardsYet": "No cards yet. Once the agent writes one, it appears here.",
    "noLensHint": "no lens — flat list of all cards",
    "nothingToExport": "nothing to export yet",
    "readyBody_one": "You have {{count}} card. Pick a frame to organize them — the agent can suggest one based on what you've written, or you can pick a template.",
    "readyBody_other": "You have {{count}} cards. Pick a frame to organize them — the agent can suggest one based on what you've written, or you can pick a template.",
    "readyToOrganize": "READY TO ORGANIZE",
    "rename": "Rename",
    "renameFramePrompt": "Rename frame",
    "seeDeletedHint": "see cards that have been deleted",
    "showArchived": "Show archived",
    "showArchivedHint": "Soft-hidden cards (e.g. test/junk) — kept in the DB so wikilinks resolve, hidden by default from the lens",
    "staleDocsAria_one": "{{count}} stale document",
    "staleDocsAria_other": "{{count}} stale documents",
    "staleDocsHint_one": "{{count}} saved document may be stale — open to review",
    "staleDocsHint_other": "{{count}} saved documents may be stale — open to review",
    "unplaced": "UNPLACED",
    "unplacedHint": "no clear bucket — drag to a node when you decide",
    "viewHidden_one": "View hidden ({{count}})",
    "viewHidden_other": "View hidden ({{count}})",
    "staleDemoPrompt": "Try the killer mechanic: edit this decision and watch dependent cards flag themselves stale.",
    "staleDemoCta": "TRY IT",
    "staleDemoDismiss": "Dismiss"
  },
  "columnResizer": {
    "resizeHandle": "Resize discussion panel. Arrow keys to adjust, shift for larger steps, double-click or Enter to reset.",
    "showCards": "Show cards"
  },
  "common": {
    "back": "Back",
    "cancel": "Cancel",
    "close": "Close",
    "delete": "Delete",
    "edit": "Edit",
    "loading": "Loading…",
    "refresh": "Refresh",
    "retry": "Retry",
    "save": "Save"
  },
  "computed": {
    "badgeTooltip": "A value on this card was verified by a python_compute sandbox run. Open the card to see the code.",
    "durationMs": "{{ms}} ms",
    "exitCode": "exit {{code}}",
    "inputs": "inputs:",
    "label": "π computed",
    "runNumber": "run #{{id}}",
    "stdout": "STDOUT"
  },
  "confirm": {
    "confirm": "Confirm"
  },
  "dcard": {
    "stale": "STALE"
  },
  "deleted": {
    "backToCards": "back to cards",
    "byAgent": "BY AGENT",
    "byFs": "BY FS",
    "byYou": "BY YOU",
    "daysAgo": "{{count}}d ago",
    "emptyState": "no deleted cards yet",
    "groupAgentEdit": "Agent deleted",
    "groupFsDelete": "fs deletes",
    "groupOther": "Other",
    "groupRejectedGap": "Rejected gaps",
    "groupResolvedGap": "Resolved gaps",
    "groupUserDelete": "You deleted",
    "heading": "DELETED",
    "viewFullHistory": "view full history",
    "yesterday": "yesterday"
  },
  "discussion": {
    "addToCards": "Add to cards",
    "addToOpen": "Add to OPEN",
    "agentDecidesHint": "agent decides when to write cards",
    "answerNow": "Answer now",
    "attachRefTooltip": "attach a project ref",
    "attachedChipTooltip": "attached as a project ref · click × to drop the auto-mention",
    "attachedRemoveAria": "remove {{name}}",
    "bulkAcceptAll": "Accept all ({{parts}})",
    "bulkAddAllToCards": "Add all to cards ({{count}})",
    "bulkAddAllToOpen": "Add all to OPEN ({{count}})",
    "bulkApproveAllTooltip": "approve every proposal in this burst",
    "bulkBreakdownAllQuestions": "(all questions)",
    "bulkBreakdownAllSettled": "(all settled)",
    "bulkBreakdownMixed": "({{questions}} questions, {{other}} other)",
    "bulkExpandTooltip": "show each proposal individually so you can act on them one at a time",
    "bulkPartCards": "{{count}}→cards",
    "bulkPartOpen": "{{count}}→OPEN",
    "bulkProposalsCount": "{{count}} proposals",
    "bulkProposalsExpanded": "{{count}} proposals · expanded",
    "bulkRejectAllTooltip": "dismiss every proposal in this burst",
    "clickToDismiss": "click to dismiss",
    "collapse": "collapse",
    "composerDropPlaceholder": "drop to attach as project ref",
    "composerPlaceholder": "Think out loud with the agent…",
    "convertItemsMany": "↳ CONVERT {{count}} ITEMS → OPEN",
    "convertItemsOne": "↳ CONVERT {{count}} ITEM → OPEN",
    "convertTooltip": "Run a scoped decompose-distill on this single message and surface the items in OPEN.",
    "converting": "CONVERTING…",
    "discuss": "Discuss",
    "dismiss": "Dismiss",
    "dismissAll": "Dismiss all",
    "distillButton": "DISTILL ⌘D",
    "distillTooltip": "Review the conversation and propose cards we should have written",
    "distilling": "DISTILLING…",
    "emptyBody": "The agent talks freely, asks probing questions, and writes cards when the moment is clear. You can always Distill at the end to capture what was missed.",
    "emptyTitle": "Start with a vague idea.",
    "expand": "expand",
    "headerTitle": "DISCUSSION",
    "jumpToLatestTooltip": "Jump to the latest message",
    "newReplyMany": "↓ {{count}} NEW REPLIES",
    "newReplyOne": "↓ {{count}} NEW REPLY",
    "openProjectFirst": "open a project first",
    "pinnedApproveQuestionTooltip": "questions can't be approved — write an answer then archive",
    "pinnedApproveTooltip": "promote → {{kind}} (its proposed kind)",
    "pinnedBadgeAnswering": "✦ ANSWERING {{id}}",
    "pinnedBadgeDiscussing": "✦ DISCUSSING {{id}}",
    "pinnedRejectTooltip": "dismiss — delete the gap and mark blocks as dismissed",
    "pinnedResolveTooltip": "Stop steering the conversation toward this gap (gap stays in ledger)",
    "pinnedWhyPrefix": "why:",
    "postResolveDismiss": "DISMISS",
    "postResolvePrefix": "Resolved",
    "postResolveSuffix": ". Did this discussion surface new gaps?",
    "queuedCancelAria": "cancel queued send",
    "queuedChipTooltip": "queued — sends when the current turn finishes · × to cancel",
    "queuedImageMany": "({{count}} images)",
    "queuedImageOne": "({{count}} image)",
    "queuedPrefix": "↵ queued:",
    "resolve": "Resolve",
    "roleAgent": "✦ AGENT · {{time}}",
    "roleYou": "YOU · {{time}}",
    "runAudit": "RUN AUDIT",
    "sandboxRunning": "🐍 sandbox 跑代码中",
    "sendButtonQueue": "queue",
    "sendButtonQueueTooltip": "queue (↵) — sends when current turn finishes",
    "sendButtonSend": "send",
    "sendButtonSendTooltip": "send (↵) · ⇧↵ for newline",
    "sendButtonStop": "stop",
    "sendButtonStopAria": "stop in-flight turn",
    "sendButtonStopTooltip": "stop — abort the in-flight turn",
    "thinkingChars": "{{count}} chars",
    "thinkingLabel": "✦ THINKING · {{time}}",
    "thinkingPlaceholder": "✦ thinking",
    "tierChipTooltip": "Tier: {{tier}}{{suffix}} — click to change",
    "tierCustomLabel": "Custom:",
    "tierDefaultBadge": "DEFAULT",
    "tierEffortHeading": "EFFORT",
    "tierEffortIgnoredTooltip": "Fast mode is on — effort is ignored at request time.",
    "tierFastMode": "Fast mode",
    "tierFastModeTooltip": "Skip thinking entirely. Trade reasoning quality for first-byte latency.",
    "tierModelsHeading": "MODELS",
    "tierResetToDefault": "RESET TO DEFAULT",
    "tierVisionStickyNote": "This thread has images. The server auto-routes to a vision-capable model so prior turns stay readable, regardless of selection.",
    "tierVisionStickyTooltip": "Vision sticky: this thread has images, so the server routes to a vision-capable model regardless of selection. Click to change anyway.",
    "toolApproveQuestionTooltip": "add to OPEN QUESTIONS as a tracked open question",
    "toolApproveTooltip": "add to cards as {{kind}}",
    "toolApprovedSummary": "✓ approved → {{id}} ({{kind}})",
    "toolDiscussQuestionTooltip": "open a thread to answer this question with the agent",
    "toolDiscussTooltip": "open a thread to refine this proposal before accepting",
    "toolJumpTooltip": "click to jump to {{id}}",
    "toolRejectTooltip": "dismiss — delete the proposal and mark blocks as dismissed",
    "toolToggleTooltip": "click to toggle full input",
    "truncatedLabel": "⚠ TRUNCATED · max_tokens reached — response cut off",
    "truncatedTooltip": "The model stopped because it hit max_tokens. Raise DRAFTLIZE_MAX_TOKENS or ask the agent to continue.",
    "untitledGap": "(untitled gap)",
    "untitledQuestion": "(untitled question)",
    "uploadFailed": "upload failed: {{error}}",
    "uploading": "uploading {{count}}…",
    "working": "Working…"
  },
  "distill": {
    "blocksPrefix": "blocks:",
    "cardsSection": "CARDS · {{selected}} of {{total}}",
    "cardsSectionHint": "crystallised content — lands directly via write_card on commit",
    "commit": "Commit {{count}}",
    "extractedSoFar": "extracted {{count}} items so far",
    "failed": "Distill failed: {{message}}",
    "gapsSection": "GAPS · {{selected}} of {{total}}",
    "gapsSectionHint": "open items — surface in OPEN via propose_card on commit",
    "headerHint": "cards: write directly · gaps: surface in OPEN",
    "heading": "Distill thread",
    "hintAudit": "project-wide gap inventory against an audit lens · output is mostly gaps with priority",
    "hintDecompose": "explode the agent’s structured artifacts (listicles / hierarchies) into atomic items",
    "hintRescue": "capture missed crystallisations from this thread · light bias toward gaps",
    "modeAudit": "Audit",
    "modeDecompose": "Decompose",
    "modeRescue": "Rescue",
    "nothingToExtract": "Nothing to extract.",
    "nothingToExtractHint": "The thread didn't surface any new crystallised content or open items. Either it's still exploratory, or the agent already captured it mid-flow.",
    "reading": "reading…",
    "scanning": "SCANNING THE THREAD",
    "scanningHint": "cards + gaps from the conversation",
    "selectedBreakdown": "({{cards}} cards · {{gaps}} gaps)",
    "selectedCount": "{{selected}} of {{total}} selected",
    "whyPrefix": "why:"
  },
  "documents": {
    "cardCount": "{{count}} cards",
    "confirmDelete": "Delete \"{{title}}\"? This can't be undone.",
    "emptyBody": "Pick a template on the left to generate a fresh doc from your cards. Saved docs reappear in this list; we'll flag them stale when source cards change so you know to regenerate.",
    "emptyList": "No saved documents yet. Pick a template above to generate one.",
    "emptyTitle": "Long-form lives here.",
    "errDelete": "delete: {{message}}",
    "heading": "Documents",
    "newFromTemplate": "+ NEW FROM TEMPLATE",
    "regenerate": "Regenerate",
    "savedCount": "{{count}} saved",
    "stale": "STALE",
    "staleBanner": "One or more source cards have changed since this was generated.",
    "templatesToggle": "▴ Templates",
    "share": "Share",
    "shareCopied": "Link copied"
  },
  "frame": {
    "acceptAndUse": "Accept and use",
    "designSectionHeading": "DESIGN A FRAME FROM YOUR CARDS",
    "designingBody": "Reading your cards and building a topology grounded in what you've actually written. {{seconds}}s elapsed.",
    "designingCardCount": "{{count}} CARDS",
    "designingTopology": "DESIGNING TOPOLOGY",
    "errCloneFailed": "clone failed: {{message}}",
    "errLoadTemplates": "load templates: {{message}}",
    "errSaveFailed": "save failed: {{message}}",
    "errSuggestFailed": "suggest failed: {{message}}",
    "haveAgentDesign": "Have agent design one",
    "headingAdd": "Add a frame",
    "headingSuggested": "Suggested frame",
    "meceTag": "[MECE]",
    "nodeCount": "{{count}} nodes",
    "orPickTemplate": "OR PICK A TEMPLATE",
    "proposedTopology": "PROPOSED TOPOLOGY · {{nodes}} NODES · DERIVED FROM {{cards}} CARDS",
    "recommendedByPack": "★ recommended by {{pack}} pack",
    "saving": "SAVING",
    "suggestNeedMore": "Need at least 6 cards (you have {{count}}). Keep chatting and try again.",
    "suggestReady": "Reads your {{count}} cards and proposes a topology grounded in what you've actually written. ~10–30s."
  },
  "gaps": {
    "answer": "answer",
    "answerTitle": "open a thread to work through this question with the agent",
    "approveTitleCard": "add as {{kind}} (joins the cards column)",
    "approveTitleQuestion": "add as a question in OPEN QUESTIONS",
    "approveToCards": "Add to cards",
    "approveToOpen": "Add to OPEN",
    "archive": "archive",
    "archiveTitle": "soft-hide this question — wikilinks still resolve",
    "auditButton": "+ AUDIT",
    "auditGapsButton": "+ AUDIT GAPS",
    "auditInProgress": "audit in progress…",
    "auditNeedsThread": "Open or create a thread first",
    "auditTitle": "Run a project-wide gap audit — fans out specific gaps into OPEN",
    "auditingBusy": "AUDITING…",
    "blocksLabel": "blocks:",
    "citedLabel": "cited:",
    "citedTitle": "hover to highlight cited turns; click a turn id to jump there",
    "collapse": "collapse",
    "discuss": "Discuss",
    "discussTitle": "pin this gap to the discussion and resolve it together",
    "dismiss": "Dismiss",
    "dismissTitle": "dismiss — delete the proposal and mark blocks as dismissed",
    "emptyState": "Nothing open. Items land here when the agent flags an unknown, proposes a card, or you run an audit.",
    "expand": "expand",
    "frameLabel": "frame",
    "heading": "OPEN",
    "hidePanel": "hide OPEN panel",
    "jumpTo": "jump to {{id}}",
    "jumpToTurn": "jump to {{turn}} in the discussion",
    "nodeEmpty": "{{label}} is empty",
    "openCard": "open this card",
    "openProbeCount": "open {{count}} probe questions",
    "openProbePopover": "open probe popover",
    "priorityNone": "UNSORTED",
    "priorityP0": "P0 — BLOCKER",
    "priorityP1": "P1 — SUBSYSTEM",
    "priorityP2": "P2 — POLISH",
    "priorityP3": "P3 — INFRA / OPS",
    "questionLabel": "question",
    "railExpand": "expand OPEN panel",
    "railExpandCount": "{{count}} open items — click to expand",
    "refsLabel": "refs:",
    "sectionFrameGaps": "FRAME GAPS",
    "sectionOpenQuestions": "OPEN QUESTIONS",
    "sectionPendingReview": "PENDING REVIEW",
    "sectionStaleRipple": "STALE RIPPLE",
    "untitled": "(untitled)",
    "untitledProposal": "(untitled proposal)",
    "untitledQuestion": "(untitled question)",
    "whyPrefix": "why:"
  },
  "generate": {
    "copied": "Copied ✓",
    "copyMarkdown": "Copy markdown",
    "copyTitle": "copy markdown to clipboard",
    "downloadMd": "Download .md",
    "downloadTitle": "download as .md",
    "fromCards": "from {{count}} cards",
    "heading": "Generated · {{template}}",
    "saveFailed": "Save failed: {{message}}",
    "saveTitle": "save document to project",
    "saved": "Saved ✓",
    "savedTitle": "document saved",
    "saving": "Saving…",
    "streaming": "streaming…",
    "titlePlaceholder": "Document title…",
    "viewRaw": "Raw",
    "viewRendered": "Rendered",
    "waitStreaming": "wait for streaming to finish"
  },
  "history": {
    "byAgent": "BY AGENT",
    "byFs": "BY FS",
    "byYou": "BY YOU",
    "closeAria": "Close history",
    "current": "CURRENT",
    "daysAgo": "{{count}}d ago",
    "diffNoPrior": "diff (no prior rev)",
    "diffVsRev": "diff vs rev {{rev}}",
    "fieldBody": "body",
    "fieldKind": "kind",
    "fieldPack": "pack",
    "fieldTitle": "title",
    "filterFs": "fs",
    "filterFsTooltip": "show file-system edits (vim, Obsidian, git pull)",
    "filterMetadata": "metadata",
    "filterMetadataTooltip": "show revs where only extra/metadata changed (e.g. dismissed_gaps)",
    "hiddenCount": "{{count}} hidden",
    "noMatch": "no revisions match the current filters",
    "none": "(none)",
    "opDelete": "DELETE",
    "opFs": "FS",
    "opPatch": "PATCH",
    "opPromote": "PROMOTE",
    "opWrite": "WRITE",
    "restore": "Restore",
    "restoreConfirm": "Restore",
    "restoreMessage": "The current body of {{cardId}} will be overwritten with this revision's content. The restore itself is recorded as a new rev — nothing is lost, but the change is visible in History.",
    "restoreTitle": "Restore rev {{rev}}?",
    "restoreTooltip": "restore this rev as the current body",
    "restoring": "Restoring…",
    "revCount_one": "{{count}} rev",
    "revCount_other": "{{count}} revs",
    "revLabel": "rev {{rev}}",
    "snapshot": "snapshot",
    "startsHere": "history starts here",
    "title": "HISTORY",
    "undeleteConfirm": "Undelete",
    "undeleteMessage": "The card will be re-created from this revision's content. The restore is recorded as a new rev so the deletion event is preserved in History.",
    "undeleteTitle": "Undelete {{cardId}}?",
    "yesterday": "yesterday"
  },
  "homepage": {
    "ccBullet1Body": "· plus thread + document readers. Writes lock to fact / statement / question — decisions stay yours.",
    "ccBullet1Label": "MCP · READ",
    "ccBullet1Title": "Five read tools, one safe write",
    "ccBullet2BodyPart1": "Build-session findings post back as gap cards tagged",
    "ccBullet2BodyPart2": ". You triage in the ledger; the CLI never lands decisions for you.",
    "ccBullet2Label": "CLI · PROPOSE",
    "ccBullet2Title": "flag · fact · mark-built",
    "ccBullet3BodyPart1": "Once a card is",
    "ccBullet3BodyPart2": ", edits to its body trip the drift bit. The UI shows where the spec moved without the code following.",
    "ccBullet3Label": "DRIFT DETECTION",
    "ccBullet3Title": "Spec ↔ code auto-flag",
    "ccHeadingLine1": "Cards as ambient context.",
    "ccHeadingLine2": "Findings as gap proposals.",
    "ccIntroPart1": "Draftlize ships as an",
    "ccIntroPart2": "(independent",
    "ccIntroPart3": "binary) and a",
    "ccIntroPart4": "that mirrors cards into your repo. Claude Code, Cursor, and vim read them as ambient context; findings come back as gap proposals for you to triage.",
    "ccIntroStrong1": "MCP server",
    "ccIntroStrong2": "CLI",
    "ccLabel": "FIG. 5 · EXTERNAL AGENTS",
    "compareColChatGPT": "ChatGPT / Claude",
    "compareColDraftlize": "Draftlize",
    "compareColLinear": "Linear Docs",
    "compareColNotion": "Notion AI",
    "compareHeading": "Built for product thinking,",
    "compareHeadingEm": "not generic notes.",
    "compareIntro": "Generic notes apps were built for static documents. ChatGPT was built for stateless chats. Draftlize is the first substrate where your product decisions compound across conversations, agents, and sprints.",
    "compareLabel": "Why Draftlize",
    "compareLegendNo": "—",
    "compareLegendPartial": "partial",
    "compareLegendYes": "native",
    "compareRow1": "Persistent context across chats",
    "compareRow2": "Auto-flag stale dependencies when a spec changes",
    "compareRow3": "Decisions are addressable, not buried in prose",
    "compareRow4": "Cross-thread conflict detection",
    "compareRow5": "First-class context for Claude Code / Cursor / MCP",
    "compareRow6": "Card-level history + provenance (who decided, when, why)",
    "compareRow7": "Export your full graph as markdown anytime",
    "demoAriaLabel": "Stale propagation demo",
    "demoButtonIdle": "REWRITE c-04 →",
    "demoButtonReset": "RESET ↻",
    "demoButtonWriting": "WRITING…",
    "demoByYou": "BY YOU",
    "demoCardDecision": "Magic system: {{value}}",
    "demoCardDecisionPrefix": "Magic system:",
    "demoCardQuestion": "How does the UI show element-switching once a second slot unlocks?",
    "demoCardStatement1": "Boss \"Pyrhad\" weakness — water burst dmg drives the fight pacing",
    "demoCardStatement2": "Stage 3 hidden route requires at least one earth-element character",
    "demoNarrateIdle": "Change one decision · watch dependents flag stale",
    "doc1Bul1": "Free 0.1× quota drives Pro conversion",
    "doc1Bul2": "Max may cannibalize self-host path",
    "doc1Cards": "14 CARDS",
    "doc1Hdg1": "## Background",
    "doc1Hdg2": "## Decision",
    "doc1Hdg3": "## Trade-offs",
    "doc1Hdg4": "## Open",
    "doc1Row1": "Target: indie cafe owners, $25 tooling ceiling",
    "doc1Row2": "Prepaid wallet · pay as you go · $5 free",
    "doc1Row3": "Heavy-usage persona",
    "doc1Stale": "2 STALE",
    "doc2Cards": "9 CARDS",
    "doc2Hdg1": "1 · The Problem",
    "doc2Hdg2": "2 · The Mechanic",
    "doc2Hdg3": "3 · The Demo",
    "doc2Hdg4": "4 · Market",
    "doc2Hdg5": "5 · Business",
    "doc2Row1": "AI chats decay past turn 30",
    "doc2Row2": "Card graph + stale propagation",
    "doc2Row3": "UC-01 happy path",
    "doc2Row4": "AI-native operators",
    "doc2Row5": "Prepaid wallet",
    "doc3Body1Em": "argument stops deepening",
    "doc3Body1Part1": "By the thirtieth turn, most people find the same thing: the",
    "doc3Body1Part2": "and starts thinning. The model isn't broken — the artifact is missing…",
    "doc3Body2Em": "decision",
    "doc3Body2Part1": "Rewrite one",
    "doc3Body2Part2": "card. Every dependent thought flags stale, struck through and amber-tinted…",
    "doc3Cards": "6 CARDS",
    "doc3Hdg1": "Why Draftlize",
    "doc3Hdg2": "The Mechanic",
    "doc3Stale": "1 STALE",
    "doc4Bul1": "Vision · one-line position",
    "doc4Bul2": "Why this exists (two beliefs)",
    "doc4Bul3": "└ Output, not notes",
    "doc4Bul4": "└ Thinking IS collab",
    "doc4Bul5": "What carries from v3",
    "doc4Bul6": "Edge — PG as SoT",
    "doc4Bul7": "Success criteria (5)",
    "doc4Cards": "22 CARDS",
    "docClean": "CLEAN",
    "docTemplate1Label": "TEMPLATE 01",
    "docTemplate2Label": "TEMPLATE 02",
    "docTemplate3Label": "TEMPLATE 03",
    "docTemplate4Label": "TEMPLATE 04",
    "docsHeadingLine1": "Generate the draft.",
    "docsHeadingLine2": "Keep the cards as truth.",
    "docsIntroEm": "derived views",
    "docsIntroPart1": "Documents are",
    "docsIntroPart2": ". Each row stores template + markdown +",
    "docsIntroPart3": ". When a referenced card changes, a background detector pushes",
    "docsIntroPart4": "via SSE — the amber dot appears the moment the source drifts.",
    "docsLabel": "FIG. 4 · LONG-FORM OUTPUT",
    "edition": "VOL. 1 · 2026 EDITION",
    "faq1AnswerPart1": "No — Draftlize is prepaid, so there's nothing to cancel. Sign up and get $5 in credit, then pay only for what you use. Your balance",
    "faq1AnswerPart2": "never expires, and you can export everything anytime.",
    "faq1Question": "Do I need a subscription?",
    "faq2Answer": "Yes, anytime. Full markdown export of every card, thread, document, history, and ref file. Plain files — no lock-in, no proprietary format. Take it to Obsidian, Notion, vim, or wherever you want.",
    "faq2Question": "Can I export my data?",
    "faq3Answer": "Your cards stay yours. We don't train models on your data, ever. Server runs stateless containers on Fly.io; data lives in your tenant-scoped Postgres + Tigris S3. Full data deletion request honored within 7 days.",
    "faq3Question": "What about privacy / data ownership?",
    "faq4Answer": "Drop existing markdown / PDF / docs into the _refs/ panel and the agent extracts cards from them. There's no one-click import yet — but the agent reads anything you give it and proposes cards you accept or reject one by one. Most PMs report 30-60 min to seed a useful project from existing docs.",
    "faq4Question": "How do I migrate from Notion / Linear / a folder of docs?",
    "faq5Answer": "No plan tier and no hard cap — usage is drawn from your wallet balance as you work. When the balance runs low you top up any time from Settings → Billing, starting at $5, and credit lands instantly so you're never blocked mid-flow. Whatever you don't spend stays in your wallet and never expires.",
    "faq5Question": "Is there a usage cap?",
    "faqHeading": "Common questions",
    "finalBody": "Bring your product thinking into a substrate that AI agents can read AND write. Start with $5 free, pay as you go, balance never expires.",
    "finalCta": "ENTER WITH INVITE CODE",
    "finalHeadingLine1": "Stop losing the artifact.",
    "finalHeadingLine2": "Start keeping it.",
    "footerAriaGitHub": "Sign in with GitHub",
    "footerAriaGoogle": "Sign in with Google",
    "footerAriaMagicLink": "Sign in via email magic link",
    "footerBlurb": "An agent-native idea incubator. Built on a self-hosted Rust agent, Postgres + pgvector, S3-backed refs. Closed-source SaaS — your data exports as markdown any time you ask.",
    "footerContact": "CONTACT",
    "footerEdition": "VOL. 1 · ISSUE 1 · GLOBAL EARLY ACCESS · 2026 EDITION",
    "footerGitHub": "GITHUB",
    "footerGoogle": "GOOGLE",
    "footerLanguage": "LANGUAGE",
    "footerLanguageNote": "per-thread override",
    "footerMagicLink": "MAGIC LINK",
    "footerPrivacy": "PRIVACY",
    "footerSignIn": "SIGN IN",
    "footerTerms": "TERMS",
    "founderBody": "Every new Claude chat, I'd re-explain why we killed the freemium model, what the onboarding decision was, why we picked Stripe over Lemon. By the third sprint I realized I wasn't doing product work — I was doing context recovery. So I built a substrate where AI can read AND write the decisions, not just see them in chat history. Draftlize is what I use every day. If you're a PM who lives in AI chats and lose half your week to re-explaining, you're the user I'm building for.",
    "founderHeading": "From a PM who got tired of",
    "founderHeadingEm": "re-explaining context.",
    "founderLabel": "Why I built this",
    "founderSig": "— Draftlize founder",
    "gainLabel": "GAIN",
    "heroCtaReadMechanic": "READ THE MECHANIC",
    "heroCtaStartFree": "ENTER WITH INVITE CODE",
    "heroLabel": "Limited beta — invite only",
    "heroLedePart1": "For PMs and product designers. Every spec, decision, and rationale becomes an",
    "heroLedePart2": ". Change one spec — every dependent thread is",
    "heroLedePart3": ". Decisions stop getting re-litigated every sprint.",
    "heroLedeStrong1": "addressable card",
    "heroLedeStrong2": "auto-flagged stale",
    "heroRoiLine": "PMs lose 5+ hours/week re-explaining context to AI. Draftlize keeps it.",
    "heroStack1": "SELF-HOSTED RUST AGENT",
    "heroStack2": "POSTGRES + PGVECTOR",
    "heroStack3": "MCP + CLI · CLAUDE CODE-READY",
    "heroTitleLine1": "Think with an agent.",
    "heroTitleLine2": "Keep the artifact.",
    "mechanic1BodyPart1": "Each card is a structured atom —",
    "mechanic1BodyPart2": " Wikilinks draw the edges. No \"main doc + attachments\" duality.",
    "mechanic1Title": "Card graph IS the document.",
    "mechanic2BodyPart1": "Rewrite a",
    "mechanic2BodyPart2": "→ substrate walks",
    "mechanic2BodyPart3": "in reverse → every transitive dependent gets",
    "mechanic2BodyPart4": "UI strikes through, amber-flags.",
    "mechanic2Title": "Stale propagation as first-class behavior.",
    "mechanic3BodyPart1": "When the agent is unsure,",
    "mechanic3BodyPart2": "drops a",
    "mechanic3BodyPart3": ". Always visible, never foldable. Approve · Discuss · Reject.",
    "mechanic3Title": "Gap Ledger lives in column four.",
    "mechanic4BodyPart1": "Open many threads on one project — they share cards but not chat history. A background detector files contradictions across threads as",
    "mechanic4Title": "Multi-thread with automatic conflict detection.",
    "mechanicHeadingLine1": "Four moves",
    "mechanicHeadingLine2": "that make this not a notes app.",
    "mechanicLabel": "FIG. 1 · CORE MECHANIC",
    "mockCardDecision": "Prepaid wallet · pay as you go · balance never expires",
    "mockCardGap": "market-research/c-31 says $35–50 budget — conflicts with c-09",
    "mockCardStatement1": "Indie cafe owners cap monthly tooling at ~$25 — pay-as-you-go fits any budget",
    "mockCardStatement2": "$5 signup credit lets users try before they top up",
    "mockCards": "CARDS",
    "mockGapConflict": "Budget figure conflicts across threads",
    "mockGapInterp1": "\"indie cafe\" — include small chains?",
    "mockGapInterp2": "Heavy-usage persona undefined",
    "mockGapLedger": "GAP LEDGER",
    "mockThreads": "THREADS",
    "navDocuments": "DOCUMENTS",
    "navEarlyAccess": "EARLY ACCESS →",
    "navMechanic": "MECHANIC",
    "navPeople": "PEOPLE",
    "navPricing": "PRICING",
    "navProblem": "PROBLEM",
    "painLabel": "PAIN",
    "persona1Gain": "Cards are the persistent memory. Open a new thread, agent reads c-04 (pricing decision) and c-09 (target persona) as ambient context. Re-explanation drops to zero. Decisions stop drifting because dependent threads auto-flag when she edits a spec.",
    "persona1Name": "The Product Manager",
    "persona1Pain": "Each new chat with Claude re-litigates pricing, target persona, onboarding decisions she made weeks ago. By Friday she's spent 8 hours re-explaining context she already settled in week 2.",
    "persona1Role": "Mira — Senior PM at a Series A SaaS, runs roadmap with Claude as her thought partner",
    "persona1Snippet": "\"Cut my AI-assisted PM time from 12 hours/week to 6. Same output, half the re-explaining.\"",
    "persona1SnippetLabel": "FROM DOGFOOD · WEEK 4",
    "persona1Tag": "№ 01 · PM",
    "persona2GainPart1": "Every design decision is a card. The agent reads c-03 (color principle) and c-22 (component lockup rationale) before suggesting changes. Cross-surface contradictions surface as",
    "persona2GainPart2": "before the PR opens.",
    "persona2Name": "The Product Designer",
    "persona2Pain": "Design principles, system tokens, and component rationales live across 3 Figma files, 2 Notion pages, and 47 Loom threads. AI design conversations forget by the next sprint why he picked sentence case over title case.",
    "persona2Role": "Diego — staff Product Designer at a fintech, owns design system + 4 product surfaces",
    "persona2Snippet": "\"Caught a sentence-case violation across 3 surfaces in 5 seconds. Used to take a 30-min audit before each design review.\"",
    "persona2SnippetLabel": "FROM DOGFOOD · WEEK 6",
    "persona2Tag": "№ 02 · PRODUCT DESIGNER",
    "personasHeadingLine1": "Two roles.",
    "personasHeadingLine2Em": "context evaporation",
    "personasHeadingLine2Part1": "Two moments where",
    "personasHeadingLine2Part2": "gets expensive.",
    "personasIntro": "Draftlize earns its place where a single product shift cascades into rewriting every dependent decision. PMs and product designers feel this hardest because their thinking IS the deliverable.",
    "personasLabel": "FIG. 2 · WHO REACHES FOR DRAFTLIZE",
    "pricingTrust1": "New accounts get $5 free",
    "pricingTrust2": "Export your data anytime",
    "pricingTrust3": "No lock-in · export anytime",
    "problem1Body": "You decided pricing in week 3. Week 7, in a new chat, you and your agent argue the same trade-off from scratch — because nothing in the chat log is addressable.",
    "problem1Num": "I",
    "problem1Title": "Decisions get re-litigated every sprint",
    "problem2Body": "You change one assumption — onboarding flow, target persona, pricing tier — and every doc that depended on it silently rots. By demo day you find out which.",
    "problem2Num": "II",
    "problem2Title": "Specs drift without anyone noticing",
    "problem3Body": "New chat, new amnesia. You re-explain \"why we rejected the freemium model\" for the fifth time. Context that should compound, doesn't.",
    "problem3Num": "III",
    "problem3Title": "Your agent forgets you every conversation",
    "problemHeading": "The three pains AI-assisted product work",
    "problemHeadingEm": "silently inflicts.",
    "pullQuote": "You can think with an agent for an hour and have nothing to show for it — unless the artifact remembers.",
    "pullQuoteCite": "From Draftlize dogfood log · 2026-02",
    "surfaceClaudeCitedBody": "Prepaid wallet · pay as you go · balance never expires",
    "surfaceClaudeReplyPrefix": "From",
    "surfaceClaudeTitle": "C · CLAUDE CODE",
    "surfaceClaudeUserMsg": "what does the pricing card actually say?",
    "surfaceClaudeWhoYou": "YOU",
    "surfaceWebCaption": "→ rendered with kind glyph, hover for stale-graph preview, drag to reorder, click for full History drawer",
    "surfaceWebCardBody": "Prepaid wallet · pay as you go · balance never expires",
    "surfaceWebCardMeta": "3 DEPENDENTS · LAST EDITED 14m AGO · BY YOU",
    "surfaceWebTitle": "A · WEB UI · CardPeek",
    "surfacesHeadingEm": "become first-class context.",
    "surfacesHeadingPart1": "Two surfaces where your cards",
    "surfacesIntroPart1": "The Draftlize web app + Claude Code integration. Same card,",
    "surfacesIntroPart2": "addressable from either side. Developers get the full surface set (CLI, MCP, raw markdown) on the developer page below.",
    "surfacesLabel": "FIG. 3 · WHERE YOUR CARDS LIVE",
    "testimonial1Quote": "I changed the magic system on a Tuesday. By Wednesday I had cleared 20 dependent cards. Without stale propagation that would have been a month of bug reports.",
    "testimonial1Role": "Solo dev · roguelike",
    "testimonial2Quote": "The cross-thread conflict caught a guidance mismatch between two biotech writeups before I sent the memo. That's the kind of catch you don't appreciate until it saves your reputation once.",
    "testimonial2Role": "Investigative journalist",
    "testimonial3Quote": "Cards as ambient context for Claude Code is the killer move. The agent stops asking \"what did you decide last week\" because last week is right there in the repo.",
    "testimonial3Role": "Indie hacker · B2B tools",
    "voicesHeadingEm": "And the questions that come up.",
    "voicesHeadingPart1": "What dogfood users say."
  },
  "import": {
    "changeFile": "click or drop another to change",
    "dropZone": "Drop a draftlize export .zip here",
    "dropZoneHint": "or click to choose a file",
    "errNotZip": "Expected a .zip file, got {{name}}",
    "heading": "Import project",
    "importButton": "Import →",
    "importing": "Importing…",
    "projectNameLabel": "PROJECT NAME (OPTIONAL)",
    "projectNamePlaceholder": "leave blank to use \"<original> (imported)\""
  },
  "login": {
    "codeHint": "Or type the 6-digit code from the email:",
    "codeInvalid": "Invalid or expired code — check the email or request a new one.",
    "codeSubmit": "Sign in",
    "emailPlaceholder": "you@example.com",
    "errorSendFailed": "Could not send. Try again or use GitHub / Google.",
    "inviteInvalid": "This invite code is invalid or already used",
    "invitePlaceholder": "Invite code",
    "inviteRequired": "An invite code is required to sign up",
    "noInviteWaitlist": "No invite code? Join the waitlist",
    "sendMagicLink": "Send magic link",
    "sending": "Sending…",
    "sentBodyPrefix": "We sent a sign-in link to",
    "sentBodySuffix": ". It expires in 15 minutes and can only be used once.",
    "sentTitle": "Check your email",
    "separatorOr": "or",
    "signInWithGitHub": "Sign in with GitHub",
    "signInWithGoogle": "Sign in with Google",
    "tagline": "agent for thinking",
    "useDifferentEmail": "Use a different email",
    "waitlistBack": "Back to sign in",
    "waitlistIntro": "Draftlize is in limited beta. Leave your email and we’ll send you an invite as we open up.",
    "waitlistJoin": "Join waitlist",
    "waitlistJoinedBody": "We’ll email you an invite code as spots open up.",
    "waitlistJoinedTitle": "You’re on the list",
    "wechatHint": "Sign in with your email — we’ll send you a login link."
  },
  "refs": {
    "attach": "attach",
    "attachTitle": "attach to current message",
    "confirmDelete": "Delete ref \"{{name}}\"?",
    "dismissError": "click to dismiss",
    "emptyState": "no refs yet — drop a file or use upload below",
    "errDelete": "delete: {{message}}",
    "errLoad": "load refs: {{message}}",
    "errRead": "read: {{message}}",
    "heading": "PROJECT REFS",
    "peekTitle": "peek contents",
    "sharedAcrossThreads": "shared across threads",
    "uploadNew": "+ upload new",
    "uploading": "uploading {{count}}…"
  },
  "settings": {
    "adminBadge": "admin",
    "adminTools": "ADMIN TOOLS",
    "adminToolsHint": "Overview, LLM usage, errors triage, users.",
    "buildBinaryHint": "Build the binary first: <code>cargo build --release -p draftlize-mcp</code>",
    "copied": "✓ copied",
    "copy": "copy",
    "copyCommand": "copy command",
    "copyToken": "copy token",
    "createToken": "Create token",
    "creating": "creating…",
    "deleteConfirm": "Permanently delete \"{{name}}\"? Cards, threads, and history all go. This cannot be undone.",
    "deleteProject": "Delete project…",
    "deleting": "deleting…",
    "errClipboard": "clipboard write failed — select the text and copy manually",
    "errCreateToken": "create token: {{error}}",
    "errDelete": "delete: {{error}}",
    "errMcpToggle": "mcp toggle: {{error}}",
    "errRevokeToken": "revoke token: {{error}}",
    "errUpdatePack": "update pack: {{error}}",
    "heading": "Settings",
    "integrationsBlurb": "Let external AI tools (Claude Code, Cursor, Claude Desktop) read this project's cards over <mcp>MCP</mcp>. Read-only — they can't edit cards through this channel.",
    "wizardTitle": "Connect Claude Code",
    "wizardBlurb": "Sync this project's cards into your repo so Claude Code (or any coding agent) shares the same decision memory — and writes its findings back.",
    "wizardStep1": "Generate an API token",
    "wizardGenerate": "Generate token",
    "wizardHaveTokens_one": "You already have 1 active token — reuse it if you saved the secret, or mint a fresh one for this machine.",
    "wizardHaveTokens_other": "You already have {{count}} active tokens — reuse one if you saved a secret, or mint a fresh one for this machine.",
    "wizardStep2": "Install the CLI and link this project",
    "wizardTokenPlaceholder": "<your dft_… token>",
    "wizardCopyAll": "Copy all 4 commands",
    "wizardStep2Hint": "Pointing at a local dev server? Export DRAFTLIZE_API_URL first.",
    "wizardStep3": "Connection status",
    "wizardNoToken": "Waiting for a token — complete step 1 first.",
    "wizardWaiting": "Waiting for the first CLI call… this page re-checks every 10 s.",
    "wizardConnected": "Connected — token “{{name}}” active {{time}}.",
    "wizardIdle": "Last CLI activity {{time}} — run draftlize pull to wake it up.",
    "wizardTryNext": "Connected! Next, try <code>/draftlize:status</code> inside Claude Code.",
    "wizardDevMcp": "LOCAL DEV · MCP SERVER (DIRECT POSTGRES)",
    "wizardDevMcpBlurb": "The MCP stdio server talks straight to Postgres — it only works where you can reach the database (local dev). On any other machine, use the CLI path above.",
    "inviteCopied": "Copied",
    "inviteCopy": "Copy",
    "inviteRevoked": "Revoked",
    "inviteUsed": "Used",
    "invitesEmpty": "No codes yet. Use Draftlize for a week and grow your project past 20 cards, and 3 invite codes will appear here.",
    "invitesGrantedNow": "You just earned 3 invite codes — thanks for building with us. Share them with people who think out loud.",
    "invitesIntro": "Draftlize is in limited beta — invites let friends skip the waitlist. You earn 3 codes after a week of use and 20 cards.",
    "invitesLoadFailed": "Could not load invites — try again later.",
    "languageHint": "Sets the interface and agent reply language. Card content is never translated.",
    "languageLabel": "Language",
    "loading": "Loading…",
    "localeAuto": "Auto (follow browser)",
    "navAccount": "Account",
    "navBilling": "Billing",
    "navGeneral": "General",
    "navIntegrations": "Integrations",
    "navInvites": "Invites",
    "navTokens": "API Tokens",
    "noExternalReads": "no external reads yet",
    "noProjectGeneral": "Open a project to access general settings.",
    "noProjectIntegrations": "Open a project to manage its MCP integration.",
    "noTokens": "no tokens yet",
    "oneTimeInstall": "ONE-TIME INSTALL (in your terminal)",
    "openAdminPanel": "Open admin panel",
    "packBlank": "blank",
    "pasteIntoShell": "Paste into your shell:",
    "reallyDelete": "really delete",
    "reallyRevoke": "really revoke",
    "recentAccess": "RECENT ACCESS",
    "relDays_one": "{{count}}d ago",
    "relDays_other": "{{count}}d ago",
    "relHours_one": "{{count}}h ago",
    "relHours_other": "{{count}}h ago",
    "relMinutes_one": "{{count}}m ago",
    "relMinutes_other": "{{count}}m ago",
    "relSeconds_one": "{{count}}s ago",
    "relSeconds_other": "{{count}}s ago",
    "relYesterday": "yesterday",
    "renameHint": "rename in sidebar (double-click)",
    "revoke": "Revoke",
    "revoking": "revoking…",
    "rowEmail": "Email",
    "rowGithub": "GitHub",
    "rowName": "Name",
    "rowPack": "Pack",
    "rowProjectId": "Project ID",
    "rowStatus": "Status",
    "rowTenant": "Tenant",
    "savedDismiss": "I've saved it — dismiss",
    "saving": "saving…",
    "sectionIntegrations": "INTEGRATIONS",
    "sectionProject": "PROJECT",
    "sectionTokens": "API TOKENS",
    "session": "SESSION",
    "signOut": "Sign out",
    "signedInAs": "SIGNED IN AS",
    "signingOut": "signing out…",
    "statusConnected_one": "connected · {{count}} read in 24h",
    "statusConnected_other": "connected · {{count}} reads in 24h",
    "statusDisabled": "disabled for this project",
    "statusSetUp": "set up · no reads yet",
    "statusUnavailable": "unavailable",
    "toggleDisable": "Disable MCP for this project",
    "toggleDisableTitle": "Hide this project from MCP clients (existing reads still recorded; new reads will be refused)",
    "toggleEnable": "Enable MCP for this project",
    "toggleEnableTitle": "Re-expose this project to MCP clients",
    "tokenCreated": "created",
    "tokenCreatedNotice": "<name>{{name}}</name> — copy this now. The full token is shown only once and cannot be retrieved later.",
    "tokenLastUsed": "last used {{time}}",
    "tokenNamePlaceholder": "token name (e.g. laptop, ci-bot)",
    "tokenNeverUsed": "never used",
    "tokensBlurb": "Long-lived bearer tokens for the <code>draftlize</code> CLI and external MCP clients. Each token authenticates AS your user — treat them like passwords.",
    "unknownClient": "unknown",
    "unverified": "unverified"
  },
  "sidebar": {
    "admin": "ADMIN",
    "adminTitle": "Admin · overview / usage / errors / users",
    "archiveThread": "archive thread",
    "collapse": "collapse sidebar",
    "create": "CREATE",
    "doubleClickRename": "double-click to rename",
    "expand": "expand sidebar",
    "importFromZip": "Import from .zip",
    "mcpChipTitle": "MCP integration · open Settings → Integrations",
    "mcpChip_one": "⚡ MCP · {{count}} read",
    "mcpChip_other": "⚡ MCP · {{count}} reads",
    "newEmptyProject": "+ New empty project",
    "newMenu": "+ NEW",
    "newThread": "+ NEW",
    "noThreads": "no threads yet — start one",
    "openAccount": "Open account",
    "openAccountAria": "Open account settings",
    "openAccountTitle": "{{identity}} — open account",
    "projectNamePlaceholder": "project name…",
    "projects": "PROJECTS",
    "settings": "SETTINGS",
    "tagline": "agent for thinking",
    "threads": "THREADS",
    "untitled": "untitled"
  },
  "tips": {
    "cardShortcuts": "Open a card, then n new · e edit · esc close",
    "dragFile": "Drag a file onto the composer to attach it as a project ref",
    "editHistory": "Cards keep full edit history — open a card and tap the history drawer",
    "exportProject": "Click \"N cards\" in the cards-panel footer to download the whole project",
    "hideTips": "hide tips",
    "importZip": "+ NEW ▾ in the sidebar can also import a draftlize .zip export",
    "newline": "⇧↵ for newline · ↵ to send",
    "nextTip": "next tip",
    "projectRefs": "📎 lists project refs — attach, peek, upload, or delete",
    "renameDoubleClick": "Double-click any project or thread name to rename it",
    "settings": "⚙ Settings (bottom of sidebar) lets you swap pack or delete the project"
  },
  "usage": {
    "autoCompactionAt": "Auto-compaction at {{tokens}} ({{pct}}%)",
    "breakdownNextTurn": "BREAKDOWN (NEXT TURN)",
    "cacheRead": "Cache read",
    "cacheWrite": "Cache write",
    "chipTitle": "Context: {{input}} / {{window}} ({{pct}}%) — click for details",
    "compactedThisTurn_one": "📦 Compacted {{count}} message this turn",
    "compactedThisTurn_other": "📦 Compacted {{count}} messages this turn",
    "compactionActive": "auto-compaction active",
    "compactionActiveBody_one": "{{count}} older message gets replaced by a structured summary so the LLM stays under the input budget. Full history is still in the thread — only the LLM's view is trimmed.",
    "compactionActiveBody_other": "{{count}} older messages get replaced by a structured summary so the LLM stays under the input budget. Full history is still in the thread — only the LLM's view is trimmed.",
    "compactionActiveLabel": "📦 Compaction active:",
    "compactionHint": "Auto-compaction triggers at the orange line ({{tokens}}). Older messages get replaced by a structured summary; full history stays in the thread.",
    "contextWindow": "CONTEXT WINDOW",
    "freeSpace": "Free space",
    "input": "Input",
    "messages": "Messages",
    "messagesCompacted_one": "Messages ({{count}} compacted)",
    "messagesCompacted_other": "Messages ({{count}} compacted)",
    "mobileChipAria": "Context window {{pct}}% — tap for details",
    "mobileSheetAria": "Context window details",
    "mobileSheetTitle": "Context · {{input}} / {{window}} ({{pct}}%)",
    "output": "Output",
    "sessionTotals": "SESSION TOTALS (PROVIDER)",
    "systemPrompt": "System prompt",
    "toolsSchema": "Tools schema",
    "withoutCompaction": "Without compaction"
  },
  "marketing": {
    "footerProduct": "Product",
    "navForDevelopers": "For Developers",
    "navForPm": "For PMs",
    "navHome": "Home",
    "navOpenApp": "Open app →",
    "navStart": "Start free →",
    "navPricing": "Pricing"
  },
  "pricing": {
    "heroLabel": "Pricing",
    "prepaidHeroTitle": "Prepaid. You pay for",
    "prepaidHeroTitleEm": "what you use — nothing else.",
    "prepaidLede": "No subscription, no tiers, no monthly bill. Sign up and get $5 in credit to start, then pay only for the AI usage you actually consume. Top up whenever you like, from $5 — and whatever you don't spend stays in your wallet and never expires.",
    "prepaidHeroCta": "Start with $5 free",
    "pointsHeadingPart1": "Three things that keep it",
    "pointsHeadingEm": "honest.",
    "pointsSubhead": "Metered per token at a flat, published rate. No seats, no tiers, no invoice you didn't expect.",
    "point1Title": "Free to start",
    "point1Tag": "in credit, on signup",
    "point1Body": "Every new account gets $5 to spend however you want — no card required to begin. Enough to seed a real project and feel the loop before you pay a cent.",
    "point2Title": "Pay as you go",
    "point2Tag": "metered per token",
    "point2Body": "When the free credit runs out, top up from $5 and keep going. You're billed only for the tokens you actually use, at a flat rate — never for seats or a plan you outgrow.",
    "point3Title": "Never expires",
    "point3Tag": "your balance is yours",
    "point3Body": "Credit you've bought doesn't vanish at month's end. Step away for a quarter and come back to exactly the balance you left. No renewal, nothing to cancel.",
    "qaPrepaid1Q": "How does billing actually work?",
    "qaPrepaid1A": "Each AI request has a token-cost in cents, drawn from your wallet as you work. You start with $5 free; when it runs low, you top up from $5. No subscription, no monthly fee — you pay for usage and nothing else.",
    "qaPrepaid2Q": "Do I need a credit card to start?",
    "qaPrepaid2A": "No. The $5 in starter credit is there the moment you sign up. You only add a card to top up beyond it — and that's a one-time charge, not a recurring subscription.",
    "qaPrepaid3Q": "What happens when my balance runs out?",
    "qaPrepaid3A": "Requests pause rather than fail, so you're never charged by surprise. Top up from $5 in Settings → Billing and credit lands instantly — pick up right where you left off.",
    "qaPrepaid4Q": "Does my credit expire?",
    "qaPrepaid4A": "Never. Whatever you load stays in your wallet indefinitely. Heavy month, quiet month — your balance carries over, with no renewal and nothing to cancel.",
    "qaPrepaid5Q": "Are there still monthly plans or tiers?",
    "qaPrepaid5A": "No — the old Pro / Power / Max tiers are retired. Everyone gets the full Draftlize and pays the same per-token rate. The only thing that varies is how much you use.",
    "prepaidFinalBody": "Start with $5 free, pay only for what you use, and keep every cent you don't. That's the whole model.",
    "pageDescription": "No subscription, no tiers. Sign up with $5 in free credit and pay only for what you use across the full Draftlize: card graph, stale propagation, cross-thread conflict, Claude Code + MCP integration. Your balance never expires.",
    "pageTitle": "Pricing · Draftlize — pay as you go, $5 free to start",
    "qaHeading": "Pricing-specific questions"
  },
  "forPm": {
    "ctaBody": "Start with $5 free, then pay only for what you use — no subscription, balance never expires. Most PMs see their re-explaining time drop by 50% in the first week.",
    "ctaButton": "Get started",
    "ctaTitle": "All of Draftlize.",
    "ctaTitleEm": "Pay as you go.",
    "heroLabel": "For Product Managers",
    "heroLede": "You've already moved your product thinking into AI chats. Now stop losing it. Draftlize keeps every decision, dependency, and rationale as an addressable card the agent can read AND write — so context compounds across sprints instead of evaporating.",
    "heroTitle": "For PMs running roadmap",
    "heroTitleEm": "with an AI thought partner.",
    "pageDescription": "A workbench for PMs running roadmap with AI agents. Every spec, decision, rationale becomes an addressable card. Change one spec — every dependent thread auto-flags as stale. Cut AI-assisted PM time by ~50%.",
    "pageTitle": "For Product Managers · Draftlize — Stop re-explaining context to AI",
    "scenario1Body": "You settled your pricing model in week 3. Week 7, in a new chat, the agent reads c-04 (pricing decision) as ambient context — and starts from there. No re-explaining the analysis you already did.",
    "scenario1Title": "Pricing decisions don't get re-litigated",
    "scenario2Body": "You change the onboarding flow (c-12). Every PRD section, design doc, and Claude conversation that depended on c-12 auto-flags as stale. By the time you hit demo day you've already swept the drift.",
    "scenario2Title": "Specs stop drifting silently",
    "scenario3Body": "In thread A you say \"target SMB\". In thread B (a week later) you say \"target mid-market\". Draftlize's conflict detector files this as a gap_kind=conflict card. You see both before you ship either.",
    "scenario3Title": "Cross-thread conflicts surface as gaps"
  },
  "forDevelopers": {
    "ctaBody": "Start with $5 free, then pay only for what you use — no subscription, balance never expires. Full CLI + MCP + slash commands, all included.",
    "ctaButton": "Get started",
    "ctaTitle": "Cards as code context.",
    "ctaTitleEm": "Specs that don't drift.",
    "heroLabel": "For Developers",
    "heroLede": "Draftlize cards are the substrate. CLI mirrors them into your repo as markdown. MCP server exposes them to Claude Code, Cursor, and Claude Desktop as first-class context. When you implement c-12, mark it built — when the spec moves, status auto-flips to drift_detected and you know what to revisit.",
    "heroTitle": "Your decisions, addressable",
    "heroTitleEm": "in every AI tool you use.",
    "pageDescription": "Draftlize for spec-driven development with AI agents. CLI mirrors cards to your repo. MCP server makes cards a first-class resource for Claude Code / Cursor / Claude Desktop. Spec-status auto-flips to drift_detected when the spec moves.",
    "pageTitle": "For Developers · Draftlize — First-class context for Claude Code, Cursor, MCP",
    "surface1Body": "Cards land at `.draftlize/cards/<id>.md` as plain markdown with YAML frontmatter. Claude Code reads them as ambient context. `draftlize flag c-7 \"...\"` writes a gap card back to the GapLedger for user review.",
    "surface1Title": "CLI — `draftlize pull` to your repo",
    "surface2Body": "Independent `draftlize-mcp` binary speaks JSON-RPC over stdio. Tools: `read_card` / `list_cards` / `search_cards` / `propose_card` (locked to fact/statement/question). URI: `draftlize://<slug>/<cid>` resolvable via `/api/resolve`.",
    "surface2Title": "MCP server — stdio JSON-RPC",
    "surface3Body": "After `draftlize link <project>`, four slash commands land in `.claude/skills/draftlize/`: `/draftlize:cite` / `/draftlize:flag` / `/draftlize:fact` / `/draftlize:status`. Claude Code resolves them inline.",
    "surface3Title": "Slash commands — `/draftlize:cite c-7`",
    "surface4Body": "`draftlize mark-built c-12` flips the card's status to `built`. Edit the card later and status auto-flips to `drift_detected` — the agent knows what was implemented from which snapshot, and what's moved since.",
    "surface4Title": "implementation_status — spec drift tracking"
  },
  "share": {
    "footerCta": "Try Draftlize",
    "footerTagline": "Incubate your ideas with an agent",
    "goneBody": "The share may have been revoked by its owner.",
    "goneTitle": "This link is no longer available",
    "graphStats": "{{cards}} cards · {{edges}} connections"
  },
  "feedback": {
    "body": "Scan to join the WeChat group — direct line to the builder, ship notes, and invite codes.",
    "fab": "Early users",
    "qrAlt": "WeChat group QR code",
    "qrFallback": "Group QR coming soon — ping the friend who invited you.",
    "title": "Join the early-user group"
  },
  "onboarding": {
    "beat1Body": "No commands, no syntax. Just describe what you're working on.",
    "beat1Title": "Talk like you would to a sharp colleague.",
    "beat2Body": "When a decision, fact, or question lands, the agent writes it to the cards panel on the right — yours to edit, link, and keep.",
    "beat2Title": "Key thoughts become addressable cards.",
    "beat3Body": "Edit a card others depend on and Draftlize marks everything downstream — so your thinking stays consistent across weeks.",
    "beat3Title": "Change a decision, dependents flag stale.",
    "kicker": "WELCOME TO DRAFTLIZE",
    "skip": "I'll start on my own",
    "starter1Label": "Incubate a product idea",
    "starter1Prompt": "I'm thinking about building a product. Help me think through the core idea, who it's for, and what the riskiest assumption is.",
    "starter2Label": "Plan a feature",
    "starter2Prompt": "Help me spec a new feature. Ask me clarifying questions first, then we can capture the key decisions as we go.",
    "starter3Label": "Think through a decision",
    "starter3Prompt": "I have a decision to make and I want to reason it out loud with you. Let's lay out the options and the trade-offs.",
    "titleLine1": "Think with an agent.",
    "titleLine2": "Keep the artifact.",
    "tryOne": "TRY ONE TO START"
  }
}
